import { AppBar, Toolbar, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo_blanco.png";
import colores from "../shared/constant/styles";
import LockIcon from "@mui/icons-material/Lock";

export default function Header() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          backgroundColor: colores.rojo,
          padding: "1.8rem",
        }}
      >
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Link className="navbar-brand" to="/home">
              <img src={logo} alt="Barbieri logo" height="40" />
            </Link>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <LockIcon sx={{ fontSize: "1.6rem" }} />
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", fontSize: 16 }}
            >
              Sitio 100% seguro
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
